module.exports = __webpack_public_path__ + "media/images/fischer_banner/banner__sponsor__skyscraper__right-3e19ccc689c8c3851b8167558112a39c.png";